import React, { PureComponent } from 'react'
import Moment from 'moment';
import AuthContext from '../../../main/authenticationProvider'
import Loading from "../../../components/loading";
import AppLayout from '../../../components/layouts/AppLayout'
import { Map } from '../../../components/google/Map';
import { GoogleApiWrapper } from 'google-maps-react';
import { Row, Col, Table, Card, DatePicker, Modal, Radio, Select } from 'antd';
import { Button } from '../../../components/button'
import { TableSearch } from '../../../hooks'
import { CSVLink } from "react-csv";
import ReportsService from '../../../app/service/reportsService';
import moment from 'moment';
import PlateService from '../../../app/service/plateService';
import StorageService from '../../../app/service/storageService';

class Positions extends PureComponent {

    /**
    * Constructor
    */
    constructor(props) {
        super(props);
        this.servicePlate = new PlateService();
        this.reportsService = new ReportsService();
        this.auth = new AuthContext();
        this.tableSearch = new TableSearch();

        this.timer = null;

        this.state = {
            markers: [],
            showLoading: true,
            selectedRowKeys: [],
            loading: false,
            mapVisible: true,
            tablePageSize: 10,
            totalRegisters: 0,
            currentPage: 1,
            endDate: Moment().add(1, 'days'),
            startDate: Moment().subtract(7, 'days'),
            showModal: false,
            showPolylines: false,
            plate: StorageService.getItem("plateName") != null ? StorageService.getItem("plateName") : "",
            plates: [],
        }
    }

    /**
     * Get an index from a vector
     */
    getIndex = (value, arr, prop) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][prop] === value) {
                return i;
            }
        }
        return -1;
    }

    getPlates = () => {
        this.servicePlate
            .getPlates()
            .then(response => {
                let opt = [];
                response.data.data.forEach(item => {
                    opt.push({
                        value: item.plate,
                        label: item.plate
                    });
                });
                this.setState({
                    plates: opt,
                    loading: true,
                });

            })
            .catch(erros => {
                this.setState({
                    loading: false,
                });
                erros && erros.response && this.auth.verifyAuth(erros.response.status);
            })
    }
    /**
     * Get Table Data from backend
     */
    getData = (startDate, endDate, plate, pageSize, pageIndex) => {
        this.setState({
            showLoading: true,
            totalPages: 0
        });
        let markers = [];

        this.reportsService
            .getPositions(startDate, endDate, plate, pageSize, pageIndex)
            .then(response => {
                response.data.data.map((element, index) => {
                    markers.push({
                        key: index,
                        address: element.address,
                        date: element.date,
                        deviceId: element.deviceId,
                        direction: element.direction,
                        driverName: element.driverName,
                        horimeter: element.horimeter,
                        ignition: element.ignition,
                        input1: element.input1,
                        input2: element.input2,
                        latitude: element.latitude,
                        longitude: element.longitude,
                        mainBattery: element.mainBattery,
                        odometer: element.odometer,
                        output1: element.output1,
                        output2: element.output2,
                        plate: element.plate,
                        positionId: element.positionId,
                        rs232: element.rs232,
                        speed: element.speed,

                    });
                })
                this.setState({
                    markers: markers,
                    totalRegisters: response.data.totalRegisters,
                    showLoading: false
                });
            })
            .catch(erros => {
                this.setState({
                    showLoading: false
                });
                if (erros.response && erros.response.status === 401) {
                    this.auth.endSession();
                    this.props.history.push('/login');
                }
            })
    }

    delayOnChangeSearch = (plateName, currentPage) => {
        this.setState({
            showLoading: true
        });

        const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
        const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");
        this.getData(startDate, endDate, plateName, this.state.tablePageSize, currentPage)

    }

    /**
     * Handle component mounted getting the data using default date.
     */
    componentDidMount() {
        this.setState({
            loading: true,
        });
        this.getData(
            this.state.startDate.format('YYYY-MM-DD'),
            this.state.endDate.format('YYYY-MM-DD'),
            this.state.plate,
            this.state.tablePageSize,
            this.state.currentPage);
    }

    componentWillUnmount() {
        StorageService.removeItem("plateName");
    }

    /**
     * Handle Table click event     
     */
    handleRowClicked = row => {
        this.setState({
            selectedRow: {},
            tracks: null,
            routeSelected: null,
            triangleCoords: null,
            mapVisible: false,
        });
    }

    /*** 
     * Select Rows
     */
    selectRow = (record) => {
        const selectedRowKeys = [...this.state.selectedRowKeys];
        if (selectedRowKeys.indexOf(record.key) >= 0) {
            selectedRowKeys.splice(selectedRowKeys.indexOf(record.key), 1);
        } else {
            selectedRowKeys.push(record.key);
        }
        this.setState({ selectedRowKeys });
    }
    /**
     * 
     * Select rows
     */
    onSelectedRowKeysChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    getCSV = (temp) => {
        let opt = [];
        temp.map((element, index) => {
            opt.push({
                key: index,
                plate: element.plate,
                deviceId: element.deviceId,
                date: element.date,
                ignition: element.ignition,
                direction: element.direction,
                'mainBattery [V]': element.mainBattery,
                'odometer [m]': element.odometer,
                'horimeter [min]': element.horimeter,
                'speed [Km/h]': element.speed,
                address: element.address,
                latitude: element.latitude,
                longitude: element.longitude,
                driverName: element.driverName,
                input1: element.input1,
                input2: element.input2,
                output1: element.output1,
                output2: element.output2,
                rs232: element.rs232,
            });
        });
        return opt;
    }

    render() {

        /**
         * Select rows stuff
         */
        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectedRowKeysChange,
        };

        if (!this.state.loading) {
            this.getPlates();
        }

        /**
         * Data table columns and search/sort
         */
        const columns = [
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Placa</div>
                },
                align: 'center',
                dataIndex: 'plate',
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Dispositivo</div>
                },
                align: 'center',
                dataIndex: 'deviceId',
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Data</div>
                },
                align: 'center',
                dataIndex: 'date',
                sorter: (a, b) => a.date - b.date,
                sortDirections: ['descend', 'ascend'],
                render: (text) => moment(text).format('HH:mm:ss DD/MM/YYYY'),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Ignição</div>
                },
                align: 'center',
                dataIndex: 'ignition',
                filters: [
                    {
                        text: 'ON',
                        value: 'ON',
                    },
                    {
                        text: 'OFF',
                        value: 'OFF',
                    },
                ],
                onFilter: (value, record) => record.ignition.indexOf(value) === 0,
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Direção</div>
                },
                align: 'center',
                dataIndex: 'direction',
                sorter: (a, b) => a.direction - b.direction,
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Bateria Principal [V]</div>
                },
                align: 'center',
                dataIndex: 'mainBattery',
                sorter: (a, b) => a.mainBattery - b.mainBattery,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Odômetro [m]</div>
                },
                align: 'center',
                dataIndex: 'odometer',
                sorter: (a, b) => a.odometer - b.odometer,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Horímetro [hh:mm]</div>
                },
                align: 'center',
                dataIndex: 'horimeter',
                sorter: (a, b) => a.horimeter - b.horimeter,
                sortDirections: ['descend', 'ascend'],
                render: (text) => {
                    const hours = Math.floor(text / 60).toLocaleString('pt-br');
                    const minutes = Math.floor(text % 60);
                    return `${hours}:${minutes.toString().padStart(2, '0')}`;
                },
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Velocidade [Km/h]</div>
                },
                align: 'center',
                dataIndex: 'speed',
                sorter: (a, b) => a.speed - b.speed,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Endereço</div>
                },
                align: 'center',
                dataIndex: 'address',
                ...this.tableSearch.getColumnSearchProps('address', "Endereços"),

            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Latitude</div>
                },
                align: 'center',
                dataIndex: 'latitude',
                sorter: (a, b) => a.latitude - b.latitude,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Longitude</div>
                },
                align: 'center',
                dataIndex: 'longitude',
                sorter: (a, b) => a.longitude - b.longitude,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Motorista</div>
                },
                align: 'center',
                dataIndex: 'driverId',
                ...this.tableSearch.getColumnSearchProps('driverId', 'Motorista')
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Nome do Motorista</div>
                },
                align: 'center',
                dataIndex: 'driverName',
                ...this.tableSearch.getColumnSearchProps('driverName', 'Nome do Motorista')
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Input 1</div>
                },
                align: 'center',
                dataIndex: 'input1',
                sorter: (a, b) => a.input1 - b.input1,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>Input 2</div>
                },
                align: 'center',
                dataIndex: 'input2',
                sorter: (a, b) => a.input2 - b.input2,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>output 1</div>
                },
                align: 'center',
                dataIndex: 'output1',
                sorter: (a, b) => a.output1 - b.output1,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>output 2</div>
                },
                align: 'center',
                dataIndex: 'output2',
                sorter: (a, b) => a.output2 - b.output2,
                sortDirections: ['descend', 'ascend']
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '14px', fontWeight: 500 }}>RS 232</div>
                },
                align: 'center',
                dataIndex: 'rs232',
                sorter: (a, b) => a.rs232 - b.rs232,
                sortDirections: ['descend', 'ascend']
            }
        ];

        /**
         * Table Pagination config
         */
        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });

                const startDate = typeof this.state.startDate === 'string' ? this.state.startDate : this.state.startDate.format("YYYY-MM-DD");
                const endDate = typeof this.state.endDate === 'string' ? this.state.endDate : this.state.endDate.format("YYYY-MM-DD");
                const item = StorageService.getItem("plateName");
                this.getData(startDate, endDate, item, pageSize, page);
            },
        }

        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;

        return (
            <>
                <AppLayout>
                    <Row >
                        <Col span={24}>
                            <Card title="Histórico de Posições" style={{ height: '100%' }} bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }}>
                                <Row style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8} style={{ display: 'flex' }}>
                                        <DatePicker
                                            format={{
                                                format: 'YYYY-MM-DD 00:00:00',
                                                type: 'mask',
                                            }}
                                            placeholder='Data Inicial'
                                            onChange={(date, dateString) => {
                                                this.setState({
                                                    startDate: dateString,
                                                });
                                                this.getData(
                                                    dateString,
                                                    this.state.endDate,
                                                    StorageService.getItem("plateName"),
                                                    this.state.tablePageSize,
                                                    this.state.currentPage
                                                );
                                            }}
                                            style={{ width: '50%' }}
                                        />
                                        <DatePicker
                                            format={{
                                                format: 'YYYY-MM-DD 23:59:59',
                                                type: 'mask',
                                            }}
                                            placeholder='Data Final'
                                            onChange={(date, dateString) => {
                                                this.setState({
                                                    endDate: dateString,
                                                });
                                                this.getData(
                                                    this.state.startDate,
                                                    dateString,
                                                    StorageService.getItem("plateName"),
                                                    this.state.tablePageSize,
                                                    this.state.currentPage
                                                );
                                            }}
                                            style={{ width: '50%', marginLeft: '5%' }}
                                        />
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                        <Select
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                            }
                                            onChange={e => {
                                                this.setState({ plateName: e, currentPage: 1 });
                                                StorageService.addItem("plateName", e);
                                                this.getData(
                                                    this.state.startDate,
                                                    this.state.endDate,
                                                    e,
                                                    this.state.tablePageSize,
                                                    this.state.currentPage
                                                );
                                                // this.delayOnChangeSearch(e, 1);
                                            }}
                                            allowClear
                                            placeholder="Pesquisar por placa"
                                            options={this.state.plates ? this.state.plates : null}
                                            style={{ width: '60%', marginLeft: '130px' }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Button
                                            className='successButton'
                                            type='primary'
                                            shape="round"
                                            style={{ float: 'right', width: '150px' }}
                                        >
                                            <CSVLink
                                                data={this.getCSV(this.state.markers)}
                                                separator={";"}
                                                filename={"position_history.csv"}
                                            >
                                                Download CSV
                                            </CSVLink>
                                        </Button>

                                        <Button
                                            type="primary"
                                            shape="round"
                                            style={{ marginRight: '5px', float: 'right', width: '150px' }}
                                            onClick={(e) => {
                                                this.setState({ showModal: true });
                                            }}
                                        >
                                            Mapa
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} style={{ marginTop: "30px" }}>
                                        <Table
                                            style={{ height: '100%' }}
                                            rowSelection={rowSelection}
                                            scroll={{ x: "max-content" }}
                                            loading={this.state.showLoading}
                                            columns={columns}
                                            dataSource={this.state.markers}
                                            onRow={(record) => ({
                                                onClick: () => {
                                                    this.selectRow(record);
                                                },
                                            })}
                                            size='small'
                                            pagination={paginationTable}
                                            rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    <Modal
                        visible={this.state.showModal}
                        onOk={() => this.setState({ showModal: false })}
                        onCancel={() => this.setState({ showModal: false, selectedRowKeys: [] })}
                        footer={null}
                        width={1200}
                        style={{ top: '15px' }}
                    >
                        <Row>
                            <Col span={24}>
                                <Radio.Group
                                    onChange={e => {
                                        this.setState({
                                            showPolylines: e.target.value
                                        })
                                    }}
                                    defaultValue={false}
                                >
                                    <Radio.Button value={false}>Marcadores</Radio.Button>
                                    <Radio.Button value={true}>Polyline</Radio.Button>
                                </Radio.Group>
                            </Col>
                            <Col span={24}>
                                <div style={{ width: 1200, height: '80vh', marginTop: '15px' }}>
                                    <Map
                                        scroll={{ x: "max-content" }}
                                        selectedRows={this.state.selectedRowKeys}
                                        markers={this.state.markers}
                                        mapVisible={this.state.mapVisible}
                                        google={this.props.google}
                                        showPolylines={this.state.showPolylines}>
                                    </Map>
                                </div>
                            </Col>
                        </Row>
                    </Modal>
                </AppLayout>
            </>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: process.env.REACT_APP_API_KY_GOOGLE_MAPS,
    LoadingContainer: () => <Loading />
})(Positions);